
import { Vue } from "vue-class-component";

export default class BadgeSuccess extends Vue {}
